import React from 'react';
import { Modal, Button, Space } from 'antd';
import { ThunderboltOutlined, PoweroffOutlined, CheckOutlined } from '@ant-design/icons';
import { BulkAIModalProps } from '@/types/TTextingPlatform';

const BulkAIModal: React.FC<BulkAIModalProps> = ({
	visible,
	onClose,
	selectedMsgs,
	setBulkAIAutoreply,
	themeColor,
}) => {
	const handleEnable = () => {
		setBulkAIAutoreply(true);
	};

	const handleDisable = () => {
		setBulkAIAutoreply(false);
	};

	return (
		<Modal
			title={
				<div className="flex items-center gap-2">
					<ThunderboltOutlined className="text-yellow-500" />
					<span>Bulk AI AutoReply Settings</span>
				</div>
			}
			open={visible}
			onCancel={onClose}
			footer={null}
			centered
			width={450}
		>
			<div className="py-4">
				<div className="text-center mb-6">
					<p className="text-gray-600 mb-2">
						Update AI AutoReply settings for{' '}
						<span className="font-semibold text-gray-900">{selectedMsgs.length}</span> selected
						conversation{selectedMsgs.length !== 1 ? 's' : ''}
					</p>
				</div>

				<div className="space-y-4">
					<div className="bg-gray-50 p-4 rounded-lg">
						<h4 className="font-medium text-gray-900 mb-2 flex items-center gap-2">
							<ThunderboltOutlined className="text-yellow-500" />
							AI AutoReply
						</h4>
						<p className="text-sm text-gray-600 mb-4">
							When enabled, your AI receptionist will automatically respond to incoming messages.
						</p>

						<Space size="large" className="w-full justify-center">
							<Button
								danger
								icon={<PoweroffOutlined />}
								onClick={handleDisable}
								size="large"
								className="flex items-center gap-2"
							>
								Disable
							</Button>

							<Button
								type="primary"
								icon={<CheckOutlined />}
								onClick={handleEnable}
								size="large"
								style={{
									backgroundColor: themeColor,
									borderColor: themeColor,
								}}
								className="flex items-center gap-2"
							>
								Enable
							</Button>
						</Space>
					</div>
				</div>
			</div>
		</Modal>
	);
};

export default BulkAIModal;
